import React from 'react';
import BuildSummary from '../../BuildSummary.js';

const DesktopSidebar = ({
  selectedProducts,
  mainCategories,
  categoryConfig,
  totalPrice,
  totalTestPrice,
  onRemoveProduct,
  onNavigateToCategory,
  onShareBuild,
  onContactSales
}) => (
  <div className="hidden lg:flex lg:flex-col bg-white h-screen w-80">
    <BuildSummary
      selectedProducts={selectedProducts}
      mainCategories={mainCategories}
      categoryConfig={categoryConfig}
      totalPrice={totalPrice}
      totalTestPrice={totalTestPrice}
      onRemoveProduct={onRemoveProduct}
      onNavigateToCategory={onNavigateToCategory}
      onShareBuild={onShareBuild}
      onContactSales={onContactSales}
      compact={false}
    />
  </div>
);

export default DesktopSidebar;
